import { render, staticRenderFns } from "./footer-social.vue?vue&type=template&id=4049935a&"
import script from "./footer-social.vue?vue&type=script&lang=js&"
export * from "./footer-social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports